import { Box, FileStack, type LucideIcon } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { badgeVariants } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { LlmChatSessionScopeKind } from '../llmChatSessionScopeLabel'

type LlmChatSessionScopeBadgeProps = {
  label: string
  scopeKind: LlmChatSessionScopeKind
  className?: string
}

function scopeBadgeVariant(
  scopeKind: LlmChatSessionScopeKind
): 'outline' | 'secondary' | 'warning' {
  if (scopeKind === 'general') {
    return 'outline'
  }
  if (scopeKind === 'deleted_product') {
    return 'warning'
  }
  return 'secondary'
}

function scopeBadgeIcon(scopeKind: LlmChatSessionScopeKind): LucideIcon {
  if (scopeKind === 'general') {
    return FileStack
  }
  return Box
}

export function LlmChatSessionScopeBadge({
  label,
  scopeKind,
  className,
}: LlmChatSessionScopeBadgeProps) {
  const ScopeIcon = scopeBadgeIcon(scopeKind)

  return (
    <div className={cn('max-w-full min-w-0', className)}>
      <Tooltip delayDuration={500}>
        <TooltipTrigger asChild>
          <span
            className={cn(
              badgeVariants({ variant: scopeBadgeVariant(scopeKind) }),
              'inline-flex w-max max-w-full min-w-0 items-center gap-1 overflow-hidden text-[10px] font-normal whitespace-nowrap'
            )}
          >
            <ScopeIcon className='size-3 shrink-0' aria-hidden />
            <span className='min-w-0 overflow-hidden text-ellipsis'>
              {label}
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent side='top' className='max-w-xs wrap-break-word'>
          {label}
        </TooltipContent>
      </Tooltip>
    </div>
  )
}
